export const UPDATE_RUN_LIST = 'UPDATE_RUN_LIST';
export const DELETE_RUN_LIST = 'DELETE_RUN_LIST';
export const GET_RESULT_LIST = 'GET_RESULT_LIST';
export const GET_LOAD_PARAMS= 'GET_LOAD_PARAMS';
export const REDIRECT_TO_RESULT = 'REDIRECT_TO_RESULT';
export const REDIRECT_TO_VERIFY = 'REDIRECT_TO_VERIFY';
export const GET_VERIFY_LIST = 'GET_VERIFY_LIST';
export const REFERESH_RUN_LIST ='REFERESH_RUN_LIST';
export const SET_TAB_INDEX ='SET_TAB_INDEX';
